import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Snackbar,
  Grid,
  Paper,
  CircularProgress,
  IconButton,
} from "@mui/material";
import { Column } from "primereact/column";
import Tables from "./widgets/tables";
import DownloadTable from "./widgets/downloaddata";
import {
  GetRefreshBalance,
  UpdateBalances,
  setFilters,
  setPage,
  setRowsPerPage,
} from "../redux/slices/UpdateBalance";
import { useDispatch, useSelector } from "react-redux";
import RefreshIcon from "@mui/icons-material/Refresh";
import { keyframes } from "@emotion/react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DownloadData from "./widgets/downloaddata";
import ButtonTabs from "./widgets/buttontabs";
import moment from "moment";
import DoneIcon from "@mui/icons-material/Done";
import CancelIcon from "@mui/icons-material/Cancel";
import { CloseSuccess, TransactionPicture } from "../redux/slices/transpicture";
import { toast } from "react-toastify";
import LazyTable from "./widgets/lazytable";

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const GameUpdateBalance = () => {
  const dispatch = useDispatch();
  const { page, data, rowsPerPage, totalRequests, loading, filters } =
    useSelector((state) => state.refreshBalance);
  const [loadingId, setLoadingId] = useState(null);

  useEffect(() => {
    dispatch(GetRefreshBalance(page, rowsPerPage, filters));
  }, [page, rowsPerPage, filters]);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [selectedGame, setSelectedGame] = useState(null);
  const [allobject, setObject] = useState([]);
  const userData = useSelector((state) => state.login.user);
  const pic = useSelector((val) => val.transpic);
  const handleUpdateBalance = (data, index) => {
    setSelectedGame(true);
    dispatch(CloseSuccess());
    setObject(data);
  };

  const headers = [
    "SrNo",
    "User Name",
    "Game Name",
    "Game id",
    "Balance",
    "Date",
    "Status",
  ];

  const handleChangePage = (event, newPage) => {
    dispatch(setPage(newPage));
  };

  const handleChangeRowsPerPage = (event) => {
    dispatch(setRowsPerPage(event.target.value, 10));
    dispatch(setPage(0));
  };

  const tableData = data?.map((row, index) => [
    index + 1,
    row.name || "N/A",
    row.game || "N/A",
    row.gameid || "N/A",
    row.balance || "N/A",
    moment(row?.createdAt).format("L"),
    row.status || "N/A",
  ]);

  const handleConfirmUpdate = async (datas) => {
    setLoadingId(datas._id);
    const payload = {
      uname: userData?.name,
      mid: allobject?._id,
      ghid: datas?._id,
    };
    await dispatch(UpdateBalances(payload));
    dispatch(CloseSuccess());
    setLoadingId(null);
    // setOpenSnackbar(true);
    // setSelectedGame(null);
    // setNewBalance("");
    // setWinningAmount("");
    // setError("");
  };

  const actionBodyTemplate = (rowData, index) => {
    if (rowData?.matched) {
      return (
        <span className="text-orange-600">
          Redeem request already pending for this user.
        </span>
      );
    } else if (rowData?.bl?.includes(17)) {
      return (
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleConfirmUpdate(rowData, index)}
          disabled={loadingId === rowData._id}
          loading={loadingId === rowData._id}
        >
          Update Balance
        </Button>
      );
    }
  };

  const statusBodyTemplate = (rowData) => {
    let color, icon, statusText;

    if (rowData?.bl?.includes(8)) {
      color = "#4CAF50";
      statusText = "Approved";

      icon = (
        <>
          <DoneIcon sx={{ color: "white", fontSize: "16px" }} />
        </>
      );
    } else if (rowData?.bl?.includes(17)) {
      color = "#FFC104";
      statusText = "Pending";
      icon = (
        <>
          <DoneIcon sx={{ color: "white", fontSize: "16px" }} />
        </>
      );
    }

    return (
      <div className="flex justify-start items-center">
        <Box
          className="mr-2"
          sx={{
            width: 24,
            height: 24,
            borderRadius: "50%",
            backgroundColor: color,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {icon}{" "}
        </Box>

        {rowData?.bl?.includes(8) ? "Done" : "Pending"}
      </div>
    );
  };

  const handleRefreshBalance = () => {
    dispatch(GetRefreshBalance(page, rowsPerPage, filters));
  };
  const updateTransPic = (event) => {
    const file = event.target.files[0];
    if (file) {
      dispatch(TransactionPicture(file));
    }
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          my: 4,
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Typography variant="h5">Update Balance Requests</Typography>
          <IconButton
            onClick={() => handleRefreshBalance()}
            disabled={loading}
            sx={{
              animation: loading ? `${rotate} 1s linear infinite` : "none",
              backgroundColor: "#3f51b5",
              color: "white",
              "&:hover": {
                backgroundColor: "#303f9f",
              },
              "&:disabled": {
                backgroundColor: "#e0e0e0",
              },
            }}
          >
            <RefreshIcon />
          </IconButton>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <DownloadData
            headers={headers || []}
            tableData={tableData || []}
            fileName={"Update-balance-Requests"}
          />
        </Box>
      </Box>
      {/* <Box>
        <ButtonTabs />
      </Box> */}
      <LazyTable
        data={data}
        page={page}
        rowsPerPage={rowsPerPage}
        totalRecords={totalRequests}
        loading={loading}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        onFilterChange={(filters) => {
          dispatch(setFilters(filters));
        }}
        columns={[
          { field: "name", headerName: "User Name", filter: true },
          {
            field: "game",
            headerName: "Game Name",
            filter: true,
          },
          {
            field: "username",
            headerName: "Game ID",
            filter: true,
            render: (rowData) => (
              <Box display="flex" alignItems="center" gap={1}>
                <Typography variant="body2">{rowData.username}</Typography>
                <ContentCopyIcon
                  sx={{ cursor: "pointer", fontSize: 18, color: "#666" }}
                  onClick={() =>
                    navigator.clipboard.writeText(rowData.username)
                  }
                />
              </Box>
            ),
          },
          {
            field: "balance",
            headerName: "Wallet Balance",
            filter: true,
            render: (rowData) => `$${rowData?.balance}` || "N/A",
          },
          {
            field: "balance",
            headerName: "Game Balance",
            filter: true,
            render: (rowData) =>
              `$${rowData?.amount}/$${rowData?.winsamount}` || "N/A",
          },
          {
            field: "updatedAt",
            headerName: "Date",
            filter: true,
            render: (rowData) => moment(rowData?.updatedAt).format("L LT"),
          },
          {
            field: "attachment",
            headerName: "Attachment",
            render: (rowData) =>
              rowData?.image && (
                <img
                  className="w-10 h-10 rounded-full object-cover"
                  src={rowData?.image}
                  alt="img"
                />
              ),
          },
          {
            field: "active",
            headerName: "Status",
            filter: true,
            render: statusBodyTemplate,
          },
          {
            field: "actions",
            headerName: "Actions",
            render: actionBodyTemplate,
          },
        ]}
      />
      {false && (
        <Tables rowData={data}>
          <Column
            field="no"
            header="#"
            body={(rowData, options) => options.rowIndex + 1}
            filter
            filterPlaceholder="Search by #"
          />
          <Column
            field="name"
            header="User Name"
            filter
            filterPlaceholder="Search by User Name"
            body={(rowData) => `${rowData?.name}`}
          />
          <Column
            field="game"
            header="Game Name"
            filter
            filterPlaceholder="Search by Game Name"
          />
          <Column
            field="username"
            header="Game ID"
            filter
            filterPlaceholder="Search by Game ID"
            body={(rowData) => (
              <Box display="flex" alignItems="center" gap={1}>
                <Typography variant="body2">{rowData.username}</Typography>
                <ContentCopyIcon
                  sx={{ cursor: "pointer", fontSize: 18, color: "#666" }}
                  onClick={() =>
                    navigator.clipboard.writeText(rowData.username)
                  }
                />
              </Box>
            )}
          />

          {/* <Column
          field="createdAt"
          header="Game Before Balance"
          filter
          body={(rowData) => `$${rowData?.amount}/01` || "N/A"}
          filterPlaceholder="Search by Date"
        /> */}
          <Column
            field="balance"
            header="Wallet Balance"
            filter
            filterPlaceholder="Search by Balance"
            body={(rowData) => `$${rowData?.balance}` || "N/A"}
          />
          <Column
            field="balance"
            header="Game Balance"
            filter
            filterPlaceholder="Search by Balance"
            body={(rowData) =>
              `$${rowData?.amount}/$${rowData?.winsamount}` || "N/A"
            }
          />
          {/* <Column
          field="createdAt"
          header="Game After Balance"
          filter
          body={(rowData) => `$${rowData?.balance}/01` || "N/A"}
          filterPlaceholder="Search by Date"
        /> */}
          {/* <Column
          field="createdAt"
          header="Date"
          filter
          body={(rowData) => moment(rowData?.createdAt).format("L LT")}
          filterPlaceholder="Search by Date"
        /> */}
          <Column
            field="updatedAt"
            header="Date"
            filter
            body={(rowData) => moment(rowData?.updatedAt).format("L LT")}
            filterPlaceholder="Search by Date"
          />
          <Column
            field="image"
            header="Attachment"
            filter
            filterPlaceholder=""
            body={(rowData) =>
              rowData?.image && (
                <img
                  className="w-10 h-10 rounded-full object-cover"
                  src={rowData?.image}
                  alt="img"
                />
              )
            }
          />
          <Column
            field="status"
            header="Status"
            filter
            body={statusBodyTemplate}
            filterPlaceholder="Search by Status"
          />
          <Column body={actionBodyTemplate} header="Actions" />
        </Tables>
      )}

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        message="Balance updated successfully!"
        onClose={() => setOpenSnackbar(false)}
      />
    </>
  );
};

export default GameUpdateBalance;
